<script setup>
    import Image from '@/components/Image.vue';
    defineProps(['index','step', 'id']);
</script>

<template>
    <div block v-b-toggle="id" class="step-button config-item__header" role="tab" :class="{ 'disabled-step': step.disabled && step.disabled.value }">
        <div class="step-name">
            <div class="number">{{ index+1 }}</div>
            <div class="name step__label">{{ step.name }}</div>
        </div>
        <div class="item__selection selected-option attribute__label">
            {{ step.selected.value.label }}
            <Image :src="step.selected.value.image" :class="step.layout === 'swatches' ? 'attribute__icon' : 'no-border attribute__icon'" />
            <div class="toggle"></div>
        </div>
        <!-- <div class="row">
            <div class="col-5 step-name">
                <div class="number">{{ index+1 }}</div>
                <div class="name step__label">{{ step.name }}</div>
            </div>
            <div class="col-7 selected-option attribute__label">
                {{ step.selected.value.label }}
                <Image :src="step.selected.value.image" :class="step.layout === 'swatches' ? 'attribute__icon' : 'no-border attribute__icon'" />
                <div class="toggle"></div>
            </div>
        </div> -->
    </div>
</template>